import React from "react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white p-6 relative">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">
          Privacy Policy
        </h1>
        <p className="mt-2 text-sm sm:text-base opacity-80">
          Last updated: August 2025
        </p>
      </header>

      {/* Content Section */}
      <main className="flex-grow max-w-5xl mx-auto bg-white bg-opacity-10 rounded-2xl shadow-lg p-6 sm:p-10 overflow-y-auto text-left">
        <section className="mb-6">
          <p className="text-sm sm:text-base opacity-90 leading-relaxed">
            The terms <b>"We"</b> / <b>"Us"</b> / <b>"Our"</b> / <b>"Company"</b>{" "}
            individually and collectively refer to <b>GoPillz</b> and the terms{" "}
            <b>"You"</b> / <b>"Your"</b> / <b>"Yourself"</b> refer to the users.
          </p>

          <p className="text-sm sm:text-base opacity-90 leading-relaxed mt-4">
            This Privacy Policy is an electronic record in the form of an
            electronic contract formed under the Information Technology Act,
            2000. This Privacy Policy does not require any physical, electronic
            or digital signature.
          </p>

          <p className="text-sm sm:text-base opacity-90 leading-relaxed mt-4">
            This Privacy Policy is a legally binding document between you and{" "}
            <b>Aica Health</b> (owned by GoPillz). By accessing or using our
            platform, you agree to this Privacy Policy. If you do not agree,
            please do not use our services.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">User Information</h2>
          <p className="text-sm sm:text-base opacity-90 leading-relaxed">
            To avail certain services, users are required to provide information
            such as: name, email, gender, age, PIN code, payment details,
            medical records, biometric data, and more. This information helps us
            improve our services and personalize your experience.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">Cookies</h2>
          <p className="text-sm sm:text-base opacity-90 leading-relaxed">
            We may use cookies or similar tools to enhance user experience and
            assign unique User IDs. Cookies cannot read data from your hard
            drive. Our advertisers may also set cookies which are beyond our
            control.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">Information Sharing</h2>
          <p className="text-sm sm:text-base opacity-90 leading-relaxed">
            We do not share personal information with third parties without
            consent, except when required by law, government agencies, or to
            protect rights, prevent fraud, or ensure security. Data may also be
            shared within our group companies under strict confidentiality.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">Information Security</h2>
          <p className="text-sm sm:text-base opacity-90 leading-relaxed">
            We implement strict measures to protect your data, including
            encryption, secure servers, and restricted access. However, no
            system is completely secure, and we cannot guarantee data
            transmission over the internet is fully protected.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">Grievance Redressal</h2>
          <p className="text-sm sm:text-base opacity-90 leading-relaxed">
            Any complaints, abuse, or concerns regarding content or breach of
            these terms may be reported to our designated{" "}
            <b>Grievance Officer</b> via email or in writing, signed with
            electronic signature.
          </p>
        </section>
      </main>

      {/* Footer Section */}
      <footer className="py-4 bg-black bg-opacity-20 text-center mt-6">
        <p className="text-sm">
          Powered by <span className="font-semibold">AICA</span> | Your Smart
          Health Assistant
        </p>
        <button
          onClick={() => navigate(-1)}
          className="mt-2 px-4 py-2 bg-white text-teal-600 rounded-lg shadow hover:bg-gray-200 transition"
        >
          Go Back
        </button>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
